import { logErrorToConsole } from '../../constants';

const checkDoEnableTripConfigDecoupling = (store) => {
  try {
    const doEnableTripConfigDecoupling = store
      ?.user?.travelAgency?.settings?.doEnableTripConfigDecoupling;
    return Boolean(doEnableTripConfigDecoupling);
  } catch (error) {
    logErrorToConsole('Error occurred in checkDoEnableTripConfigDecoupling: ', error);
    return false;
  }
};

export default checkDoEnableTripConfigDecoupling;
